import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ExamLearnset } from '../models/exam-learnset.model';
import { ExamQuestion } from '../models/exam-question.model';

@Injectable({
  providedIn: 'root'
})
export class ExamService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  createExamTemplate(examTemplate: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/exam-template`, { examTemplate });
  }

  createExam(courseId: number, examLearnsets: ExamLearnset[]) {
    return this.http.post<any>(`${this.baseUrl}/exam`, { courseId: courseId, examLearnsets: examLearnsets });
  }

  getExams(courseId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/exam/course/${courseId}`);
  }

  getExam(examId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/exam/${examId}`);
  }

  createExamQuestions(examId: number): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/exam/create-questions`, { examId });
  }

  saveExamQuestions(examQuestions: ExamQuestion[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/exam-question`, { examQuestions });
  }

  generateExamResult(examId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/exam/result/${examId}`);
  }
}
